export const tickerUpdates = [
  "L姓顶流男星夜会神秘女子，电梯监控画面流出",
  "千万粉网红带货翻车，合作品牌连夜解约",
  "W姓女演员片场耍大牌，同组录音曝光",
  "男团C位被曝同时交往三人，行程时间线对不上",
  "美食博主回收食材再拍摄，后厨画面流出",
  "影帝深夜聚餐搂肩画面引热议，双方均未回应",
  "户外主播假徒步被实锤，疑定点摆拍团队运作",
];

export const heroChips = [
  { label: "今日大瓜", href: "#hot" },
  { label: "明星黑料", href: "#category" },
  { label: "网红黑料", href: "#category" },
  { label: "绯闻实锤", href: "#truth" },
  { label: "大瓜盘点", href: "#timeline" },
];

export const heroStats = [
  { label: "今日更新", value: "47" },
  { label: "累计爆料", value: "12,860" },
  { label: "实锤合集", value: "326" },
  { label: "在追吃瓜", value: "8.4万" },
];

export const featuredCase = {
  category: "明星黑料",
  title: "L姓顶流男星酒吧夜会神秘女子，电梯监控画面实锤流出",
  desc:
    "凌晨两点同回公寓，随行助理全程遮挡镜头，多方爆料时间线高度吻合。截至发稿，当事人团队尚未作出任何回应，事件仍在持续发酵。",
  cover:
    "https://readdy.ai/api/search-image?query=abstract%20empty%20theater%20stage%20with%20dramatic%20amber%20and%20crimson%20spotlight%20beams%20cutting%20through%20smoke%2C%20dark%20velvet%20backdrop%2C%20cinematic%20high%20contrast%2C%20soft%20film%20grain%2C%20no%20people%2C%20luxurious%20magazine%20cover%20mood%2C%20high%20detail&width=1000&height=640&seq=hlcg-hero-feature-01&orientation=landscape",
  heat: "98.6万",
  time: "3分钟前",
  source: "吃瓜前线",
};

export const hotRank = [
  {
    rank: 1,
    title: "千万粉网红带货翻车，合作品牌连夜下架全部链接",
    tag: "网红黑料",
    heat: "76.2万",
    thumb:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20bokeh%20light%20orbs%20on%20dark%20background%2C%20cinematic%20blur%2C%20soft%20film%20grain%2C%20no%20people%2C%20high%20detail&width=400&height=400&seq=hlcg-rank-01&orientation=squarish",
  },
  {
    rank: 2,
    title: "W姓女演员片场耍大牌，同组演员匿名爆料录音曝光",
    tag: "明星黑料",
    heat: "63.4万",
    thumb:
      "https://readdy.ai/api/search-image?query=red%20rose%20petals%20scattered%20on%20dark%20velvet%20fabric%20macro%2C%20warm%20amber%20rim%20light%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=400&height=400&seq=hlcg-rank-02&orientation=squarish",
  },
  {
    rank: 3,
    title: "某选秀男团成员私联粉丝，聊天记录截图被扒",
    tag: "绯闻实锤",
    heat: "51.8万",
    thumb:
      "https://readdy.ai/api/search-image?query=golden%20confetti%20falling%20through%20warm%20amber%20light%20on%20dark%20background%2C%20cinematic%20shallow%20depth%2C%20soft%20film%20grain%2C%20no%20people%2C%20high%20detail&width=400&height=400&seq=hlcg-rank-03&orientation=squarish",
  },
  {
    rank: 4,
    title: "头部主播数据造假，刷单群聊被前员工实锤",
    tag: "网红黑料",
    heat: "44.1万",
    thumb:
      "https://readdy.ai/api/search-image?query=stacked%20shipping%20parcels%20under%20warm%20dramatic%20side%20light%20on%20dark%20background%2C%20cinematic%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=400&height=400&seq=hlcg-rank-04&orientation=squarish",
  },
  {
    rank: 5,
    title: "Z姓小花旧照翻出，疑似早年改名换身份重新出道",
    tag: "明星黑料",
    heat: "37.5万",
    thumb:
      "https://readdy.ai/api/search-image?query=old%20printed%20photographs%20fanned%20out%20on%20dark%20wood%20desk%20under%20warm%20desk%20lamp%2C%20macro%20top%20view%2C%20cinematic%20moody%20light%2C%20no%20people%2C%20high%20detail&width=400&height=400&seq=hlcg-rank-05&orientation=squarish",
  },
];

export const feedFilters = ["全部", "明星黑料", "网红黑料", "绯闻实锤"];

export const feedCards = [
  {
    id: "feed-01",
    category: "明星黑料",
    title: "男团C位被曝同时交往三人，行程表时间线完全对不上",
    desc: "三份不同来源的行程记录互相对照，同一天出现在两座城市，粉丝后援会连夜解散应援群。",
    cover:
      "https://readdy.ai/api/search-image?query=blurred%20neon%20city%20skyline%20at%20night%20seen%20through%20rainy%20window%2C%20warm%20amber%20and%20crimson%20bokeh%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-01&orientation=landscape",
    time: "18分钟前",
    views: "12.4万",
    source: "爆料小组",
  },
  {
    id: "feed-02",
    category: "网红黑料",
    title: "美食探店博主回收食材再拍视频，后厨画面流出",
    desc: "同款菜品在三天内反复出现在不同期视频里，前员工晒出排班表与回收流程记录。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20restaurant%20kitchen%20counter%20with%20warm%20pendant%20lights%20and%20rising%20steam%2C%20dark%20editorial%20food%20photography%2C%20cinematic%20contrast%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-02&orientation=landscape",
    time: "42分钟前",
    views: "9.8万",
    source: "吃瓜前线",
  },
  {
    id: "feed-03",
    category: "绯闻实锤",
    title: "影帝被拍到与已婚导演深夜聚餐，搂肩画面引热议",
    desc: "餐厅监控时间戳与双方行程完全重合，随行人员名单曝光后话题阅读量两小时破亿。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20empty%20wine%20glasses%20on%20a%20dark%20bar%20table%20under%20warm%20amber%20light%2C%20intimate%20night%20atmosphere%2C%20cinematic%20shallow%20depth%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-03&orientation=landscape",
    time: "1小时前",
    views: "21.6万",
    source: "八卦研究所",
  },
  {
    id: "feed-04",
    category: "网红黑料",
    title: "户外主播假徒步被实锤，疑似定点摆拍团队运作",
    desc: "直播背景里的同一块岩壁在三次不同线路中出现，网友比对卫星地图后放出定位截图。",
    cover:
      "https://readdy.ai/api/search-image?query=misty%20mountain%20trail%20at%20dusk%20with%20warm%20orange%20light%20rays%2C%20lone%20empty%20path%2C%20cinematic%20atmospheric%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-04&orientation=landscape",
    time: "2小时前",
    views: "7.3万",
    source: "爆料小组",
  },
  {
    id: "feed-05",
    category: "明星黑料",
    title: "女星天价代言翻车，产品成分被检测机构点名",
    desc: "第三方检测报告显示核心成分含量与宣传不符，合作方品牌方先后悄悄撤下宣传物料。",
    cover:
      "https://readdy.ai/api/search-image?query=sleek%20cosmetic%20product%20bottles%20on%20a%20reflective%20dark%20surface%20with%20warm%20golden%20rim%20light%2C%20luxury%20beauty%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-05&orientation=landscape",
    time: "3小时前",
    views: "15.9万",
    source: "吃瓜前线",
  },
  {
    id: "feed-06",
    category: "绯闻实锤",
    title: "恋情实锤合集：三对CP同款物品比对图流出",
    desc: "从同款配饰到同一背景的窗景，网友逐帧比对整理出一份时间线高度重合的实锤图集。",
    cover:
      "https://readdy.ai/api/search-image?query=tangled%20gold%20necklaces%20and%20rings%20on%20dark%20velvet%2C%20macro%20jewelry%20editorial%20photography%2C%20warm%20amber%20highlights%2C%20cinematic%20mood%2C%20no%20people%2C%20high%20detail&width=900&height=620&seq=hlcg-feed-06&orientation=landscape",
    time: "4小时前",
    views: "33.2万",
    source: "八卦研究所",
  },
];

export const starCases = [
  {
    title: "R姓男星抠图替身拍摄，场务爆料全程不到组三天",
    meta: "影视 · 10月8日",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20empty%20red%20carpet%20staircase%20roped%20off%20under%20warm%20spotlights%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-star-01&orientation=portrait",
  },
  {
    title: "F姓女歌手假唱被现场音轨拆解，网友逐帧对比",
    meta: "音乐 · 10月8日",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20recording%20studio%20microphone%20under%20a%20warm%20spotlight%20against%20a%20dark%20background%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-star-02&orientation=portrait",
  },
  {
    title: "老牌演员直播爆粗怼网友，经纪公司连夜发声明",
    meta: "综艺 · 10月7日",
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20vanity%20mirror%20framed%20with%20warm%20round%20bulbs%2C%20dark%20atmospheric%20cinematic%20mood%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-star-03&orientation=portrait",
  },
  {
    title: "Y姓小生人设崩塌，前助理发长文控诉压榨经历",
    meta: "经纪 · 10月6日",
    cover:
      "https://readdy.ai/api/search-image?query=folded%20film%20script%20pages%20and%20a%20pen%20on%20a%20dark%20table%20under%20warm%20lamp%20light%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-star-04&orientation=portrait",
  },
];

export const netCases = [
  {
    title: "百万粉宠物博主违规饲养，被举报后连夜删视频",
    meta: "萌宠 · 10月8日",
    cover:
      "https://readdy.ai/api/search-image?query=smartphone%20ring%20light%20and%20tripod%20setup%20on%20a%20desk%20with%20warm%20studio%20glow%20on%20dark%20background%2C%20cinematic%20creator%20mood%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-net-01&orientation=portrait",
  },
  {
    title: "穿搭博主打版抄袭独立设计，原作者放出对比图",
    meta: "穿搭 · 10月7日",
    cover:
      "https://readdy.ai/api/search-image?query=fabric%20swatches%20and%20measuring%20tape%20arranged%20on%20dark%20surface%20under%20warm%20amber%20light%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-net-02&orientation=portrait",
  },
  {
    title: "带货一哥口播翻车，宣称全网最低价被扒是套路",
    meta: "直播 · 10月6日",
    cover:
      "https://readdy.ai/api/search-image?query=shopping%20livestream%20studio%20with%20softboxes%20in%20warm%20ambient%20light%2C%20empty%20set%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-net-03&orientation=portrait",
  },
  {
    title: "知识区UP主洗稿实锤，原视频逐句比对还原",
    meta: "知识 · 10月5日",
    cover:
      "https://readdy.ai/api/search-image?query=stacks%20of%20open%20notebooks%20under%20warm%20desk%20lamp%20with%20coffee%20cup%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=720&height=900&seq=hlcg-net-04&orientation=portrait",
  },
];

export const truthItems = [
  {
    label: "01",
    title: "监控时间线比对",
    desc: "多段监控时间戳交叉核对，还原当事人完整行动轨迹。",
    cover:
      "https://readdy.ai/api/search-image?query=cluttered%20evidence%20desk%20with%20scattered%20papers%20and%20a%20magnifying%20glass%20under%20a%20warm%20desk%20lamp%2C%20top%20view%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-01&orientation=squarish",
  },
  {
    label: "02",
    title: "聊天记录完整截图",
    desc: "未删减对话逐条排列，上下文关系与时间顺序一目了然。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20smartphones%20lying%20on%20dark%20table%20with%20blank%20screens%20and%20warm%20amber%20reflections%2C%20cinematic%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-02&orientation=squarish",
  },
  {
    label: "03",
    title: "同款物品细节合集",
    desc: "配饰、衣物、背景窗景逐帧比对，同款线索一次看全。",
    cover:
      "https://readdy.ai/api/search-image?query=collection%20of%20gold%20rings%20watches%20and%20chains%20laid%20out%20on%20dark%20velvet%2C%20macro%20top%20view%2C%20warm%20cinematic%20lighting%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-03&orientation=squarish",
  },
  {
    label: "04",
    title: "现场录音未删减版",
    desc: "多版本录音对比剪辑，保留原始环境音以便交叉验证。",
    cover:
      "https://readdy.ai/api/search-image?query=audio%20waveform%20visualized%20as%20warm%20glowing%20lines%20on%20a%20dark%20surface%2C%20abstract%20cinematic%20macro%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-04&orientation=squarish",
  },
  {
    label: "05",
    title: "旧照身份信息核实",
    desc: "早年影像与登记信息交叉比对，还原真实履历脉络。",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20old%20photographic%20prints%20with%20worn%20edges%20on%20dark%20wood%2C%20macro%20top%20view%2C%20warm%20amber%20side%20light%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-05&orientation=squarish",
  },
  {
    label: "06",
    title: "数据台账截图流出",
    desc: "后台数据与公开口径对照，异常波动一目了然。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20warm%20amber%20data%20chart%20lines%20on%20a%20dark%20screen%20surface%2C%20cinematic%20macro%20detail%2C%20no%20people%2C%20high%20detail&width=820&height=820&seq=hlcg-truth-06&orientation=squarish",
  },
];

export const timelineItems = [
  {
    date: "10·08",
    title: "男团退团风波",
    desc: "前队友开直播爆料内幕，双方粉丝在超话集中比对行程。",
    tag: "明星黑料",
  },
  {
    date: "09·27",
    title: "网红婚礼塌房",
    desc: "伴娘发长文控诉当事人，现场视频与说法多处对不上。",
    tag: "网红黑料",
  },
  {
    date: "09·15",
    title: "影帝争议剧集",
    desc: "片方紧急下架重新剪辑，制作方与演员各执一词。",
    tag: "绯闻实锤",
  },
  {
    date: "08·30",
    title: "双顶流恋情",
    desc: "机场同框照引发全网比对，同款行李箱细节被放大。",
    tag: "明星黑料",
  },
  {
    date: "08·12",
    title: "主播偷税风波",
    desc: "官方通报后账号集体禁言，合作方陆续发布解约声明。",
    tag: "网红黑料",
  },
];

export const hotTags = [
  "今日大瓜",
  "明星黑料",
  "网红翻车",
  "恋情实锤",
  "塌房现场",
  "人设崩塌",
  "录音曝光",
  "监控实锤",
  "深夜爆料",
  "大瓜盘点",
  "同款比对",
  "身份核实",
];